import React, {useState} from 'react';
import {connect} from 'react-redux';
import {Accordion, Checkbox} from '../../../components';

import * as Actions from '../../../store/actions';

function ConfirmationPage({isChecked, onCheck, setUrl, authWidget}) {
  const [checked, setChecked] = useState(true);

  const handleChange = e => {
    setChecked(e.target.checked);
    onCheck && onCheck(e.target.checked);
  };
  const checkedValue = isChecked ? isChecked : checked;

  return (
    <Accordion title="Confirmation page">
      <p className="text-xs text-body leading-[18px] cursor-pointer">
        Confirm verification process
      </p>

      <div className="mt-4">
        <Checkbox
          onChange={handleChange}
          noLeftPadding
          label="Use default confirmation page"
          isChecked={checked}
        />

        <label
          data-smallerlabel=""
          htmlFor="confidence_level"
          className="mt-4 mb-2"
        >
          Redirect to
          <input
            disabled={checkedValue}
            style={{cursor: checkedValue && 'not-allowed'}}
            onChange={setUrl}
            type="text"
            id="confidence_level"
            className="mt-2 text-sm"
            placeholder={authWidget?.redirect_url || 'https://dojah.io'}
          />
        </label>
      </div>
    </Accordion>
  );
}

export default connect(state => state, Actions)(ConfirmationPage);
